<template>
    <div :class="'md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-' +size">
        <div class="data-container">
            <div class="data-label text-primary" v-if="label != ''" :style="'width: ' + label_width + 'px'">{{translate(label)}}</div>
            <div class="data-point text-primary" v-if="label != ''"><b>៖</b></div>
            <div class="data-value text-primary">
                <template v-if="String(value).length > 0">{{translate(value)}}</template>
                <template v-else>{{translate("Not Available||មិនមាន")}}</template>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
      props: {
        label: {}, value:{},
        size: {
            type: String,
            default: "50"
        },
        label_width: {
            default: 280
        }
      }
    }
</script>

<style scoped>
.data-container {
    display: flex; 
    align-items: center; 
    width: 100%;
    margin: 8px 0 16px 0;
}

.data-point {
    width: 50px;
}
.data-value {
    font-weight: bold;
}

@media (max-width: 800px) {
    .data-label {
        width: 100% !important;
    }
    .data-container {
        flex-direction: column;
    }
    .data-point {
        display: none;
    }
    .data-value {
        width: 100%;
        margin-top: 10px;
        margin-left: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Review/DataLine.vue